import { render, staticRenderFns } from "./map-new.vue?vue&type=template&id=2573ca1a&"
import script from "./map-new.vue?vue&type=script&lang=js&"
export * from "./map-new.vue?vue&type=script&lang=js&"
import style0 from "./map-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports